import { BrowserRouter, Route, Routes } from 'react-router-dom'
import menu from './menu'
import EmbedFluxChart from '../components/Embed/EmbedFluxChart'

const getRoutes = (items) => {
  return items.map(({ children, url, text, component: Component, indexElement }) => {
    if(!children) {
      return !indexElement ?
        <Route key={url+text} path={url} element={<Component />} /> :
        <Route key={url+text} index element={<Component />} />
    } else {
      return <Route key={url+text} path={url} element={<Component />}>{getRoutes(children)}</Route>
    }
  })
}

function RouterComponent() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/embed/flux' element={<EmbedFluxChart />} />
        {getRoutes(menu.items)}
      </Routes>
    </BrowserRouter>
  )
}

export default RouterComponent
